var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.tooltipContent,"placement":"top"}},[_c('icon-copy',{class:_vm.iconClass})],1)}
var staticRenderFns = []

export { render, staticRenderFns }